module.exports = __webpack_public_path__ + "static/media/assembly4.5a51646d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameRocketRepair/assembly4.png
// module id = 2422
// module chunks = 0